import { commonFilter } from './filter';

export default {
  pageName: 'Hero',
  pageId: '20102',
  pagePath: '/opinion/Hero',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
